module.exports = __webpack_public_path__ + "static/img/img-1.1d642f60.png";